const propertyTypes = {
  domain: 'domain',
  email: 'email',
  subdomain: 'subdomain',
  ip: 'ip',
  custom: 'custom',
  canvas: 'canvas',
  link: 'link',
};
export const extendedPropertyTypes = {
  subdomains_wrapper: 'subdomains_wrapper',
  email_wrapper: 'email_wrapper',
};
export const nodeTypes = {
  domain: 'domain',
  email: 'email',
  subdomain: 'subdomain',
  ip: 'ip',
  custom: 'custom',
  subdomains_wrapper: 'subdomains_wrapper',
  email_wrapper: 'email_wrapper',
};

export default propertyTypes;
